import React from 'react';
import PropTypes from 'prop-types';

import { padNumber, formatDate } from '../../utils/formatting_utils';
import { ProcessAPI, FormAPI } from 'lecom-api';

export default class ActivityDetails extends React.Component {
	static propTypes = {
		cycle: PropTypes.number,
		activityTitle: PropTypes.string,
		activityStartDate: PropTypes.string,
		activityDueDate: PropTypes.string
	};

	static defaultProps = {
		cycle: 0,
		activityTitle: '-',
		activityStartDate: null,
		activityDueDate: null
	};

	getFormattedActivityCycle() {
		const activityCycle = this.props.cycle;
		return ` ${Realize.i18n.t('activity.cycle')}: ${padNumber(activityCycle, 2)}`;
	}

	renderActivityTitle() {
		return (
			<div title={this.props.activityTitle} className="activity-details__title-wrapper col s12 m8 l9">
				<span className="activity-details__title"  tabIndex="0" aria-label={this.props.activityTitle}>{this.props.activityTitle}</span>
				<span className="activity-details__cycle"  tabIndex="0" aria-label={this.getFormattedActivityCycle()}>{this.getFormattedActivityCycle()}</span>
			</div>
		);
	}

	renderActivityDueDate() {
		const dueDate = this.props.activityDueDate;

		return !!dueDate
		? this.renderActivityDate(Realize.i18n.t('activity.due_date'), dueDate)
		: <span />;
	}

	renderActivityStartDate() {
		const startDate = this.props.activityStartDate;

		return !!startDate
			? this.renderActivityDate(Realize.i18n.t('activity.start_date'), startDate)
			: <span />;
	}

	renderActivityDate(label, date) {
		return (
			<div className="activity-details__date col s6" tabIndex="0" aria-label={`${label} ${formatDate(date)}`}>
				<div className="date__label">
					{label}
				</div>
				<div className="date__value-wrapper">
					<i className="material-icons" aria-hidden="true">date_range</i>
					<span className="date__value">{formatDate(date)}</span>
				</div>
			</div>
		);
	}

	getIsMobile() {
		if(ProcessAPI.currentProcess() !== null){
			let processAPI = ProcessAPI.currentProcess();
			let isMobile = processAPI.isMobile();

			if(isMobile === true)
				return 'startDateMobile'
			else
				return ''
		}
	}

	render() {
		this.getIsMobile();
		return (
			<div className="activity-details grey lighten-3 row">
				{this.renderActivityTitle()}

				<div className="activity-details__dates-wrapper col s12 m4 l3 row">
					<div className={`activity-startDate ${this.getIsMobile()}`}>{this.renderActivityStartDate()}</div>
					<div className="activity-dueDate">{this.renderActivityDueDate()}</div>
				</div>
			</div>
		)
	}
}
